<ion-content>
  <ion-grid class="constrained-content">
    <ion-row>
      <ion-col size="12">
        <ion-card class="outline-card">
          <ion-card-header>
            <strong>Company details</strong>
          </ion-card-header>
          <ion-list lines="none">
            <ion-item>
              <ion-label>Company name</ion-label>
              <ion-input slot="end" [(ngModel)]="name" placeholder="Pied Piper"></ion-input>
            </ion-item>
            <!-- <ion-item>
              <ion-label position="stacked">Support phone number</ion-label>
              <ion-input [(ngModel)]="phone" placeholder="+1 (555) 555-5555"></ion-input>
            </ion-item> -->
          </ion-list>
        </ion-card>
      </ion-col>
      <ion-col size="12">
        <ion-card class="outline-card">
          <ion-card-header>
            <strong>Billing</strong>
          </ion-card-header>
          <ion-list lines="none">
            <ion-item *ngIf="seatsUsed > 0">
              <ion-label>Agent seats used</ion-label>
              <ion-badge color="dark" fill="outline">{{ seatsUsed }}</ion-badge>
            </ion-item>
            <ion-item>
              <ion-label>Account status</ion-label>
              <ion-badge>{{ authService.accountStatus }}</ion-badge>
            </ion-item>
          </ion-list>
          <ion-button
            size="block"
            [disabled]="isLoadingCheckout"
            *ngIf="authService.accountStatus === 'trial'"
            [routerLink]="'/upgrade'"
            routerDirection="root"
            style="margin: 10px"
          >
            <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
            <span class="text-with-left-icon">Upgrade account</span>
          </ion-button>
          <ion-button
            fill="clear"
            (click)="manageSubscription()"
            [disabled]="isLoadingCheckout"
            *ngIf="authService.accountStatus !== 'trial'"
          >
            <ion-icon name="card-outline" [hidden]="isLoadingCheckout"></ion-icon>
            <ion-spinner name="crescent" [hidden]="!isLoadingCheckout"></ion-spinner>
            <span class="text-with-left-icon">Manage subscription</span>
          </ion-button>
          <ion-button fill="clear" (click)="showSubscriptionOptions()" [disabled]="isLoadingCheckout">
            <span class="text-with-left-icon">More options</span>
            <ion-icon name="chevron-down-outline"></ion-icon>
          </ion-button>
        </ion-card>
      </ion-col>
      <ion-col size="12">
        <div style="padding: 0 15px; opacity: 0.8; font-size: 0.8rem">
          Looking to manage Admins? We've added new roles and you can manage this from the
          <a routerLink="/dashboard/people" routerDirection="root">People page</a>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer>
  <ion-toolbar class="constrained-content">
    <ion-button color="success" (click)="save()" class="save-button" [disabled]="!initialized"
      >Save changes
    </ion-button>
  </ion-toolbar>
</ion-footer>
